import { render, staticRenderFns } from "./ImageSelector.vue?vue&type=template&id=5f57bb60&scoped=true&"
import script from "./ImageSelector.vue?vue&type=script&lang=ts&"
export * from "./ImageSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ImageSelector.vue?vue&type=style&index=0&id=5f57bb60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f57bb60",
  null
  
)

export default component.exports